export type EntityType = "part" | "system" | "location";

export type FieldType = "text" | "number" | "date" | "boolean" | "select";

export interface CustomFieldDefinition {
  id: string;
  entityType: EntityType;
  fieldKey: string;
  fieldLabel: string;
  fieldType: FieldType;
  required: boolean;
  options: string[];
  sortOrder: number;
}

export const ENTITY_TYPE_LABELS: Record<EntityType, string> = {
  part: "Parts",
  system: "Systems",
  location: "Locations",
};

export const FIELD_TYPE_LABELS: Record<FieldType, string> = {
  text: "Text",
  number: "Number",
  date: "Date",
  boolean: "Yes / No",
  select: "Dropdown",
};
